<div class="modal-header">
    <h4 class="modal-title"
        [innerHtml]="('ADD_SCHEDULER'|translate)"></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Close click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="filter-for-list">
    <!--<mat-form-field class="mini-list-header" placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">-->
    <!--<input matInput [value]="projectUsers ? projectUsers.filter : null" (keyup)="applyFilter($event.target.value)"-->
    <!--[placeholder]="'SEARCH' | translate">-->
    <!--</mat-form-field>-->


    <div style="float:right">
        <form [formGroup]="schedulerForm" *ngIf="schedulerForm" (ngSubmit)="postScheduler()">
            <mat-form-field class="mini-list-header date">
                <input matInput formControlName="start_date" [matDatepicker]="picker1" required
                       placeholder="Start">
                <mat-error *ngIf="start_date.invalid">{{getErrorMessageStartDate()}}</mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="mini-list-header time">
                <mat-select formControlName="start_date_hour" [placeholder]="'HOUR' | translate" required>
                    <mat-option value="00">00</mat-option>
                    <mat-option value="01">01</mat-option>
                    <mat-option value="02">02</mat-option>
                    <mat-option value="03">03</mat-option>
                    <mat-option value="04">04</mat-option>
                    <mat-option value="05">05</mat-option>
                    <mat-option value="06">06</mat-option>
                    <mat-option value="07">07</mat-option>
                    <mat-option value="08">08</mat-option>
                    <mat-option value="09">09</mat-option>
                    <mat-option value="10">10</mat-option>
                    <mat-option value="11">11</mat-option>
                    <mat-option value="12">12</mat-option>
                    <mat-option value="13">13</mat-option>
                    <mat-option value="14">14</mat-option>
                    <mat-option value="15">15</mat-option>
                    <mat-option value="16">16</mat-option>
                    <mat-option value="17">17</mat-option>
                    <mat-option value="18">18</mat-option>
                    <mat-option value="19">19</mat-option>
                    <mat-option value="20">20</mat-option>
                    <mat-option value="21">21</mat-option>
                    <mat-option value="22">22</mat-option>
                    <mat-option value="23">23</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="mini-list-header time" style="margin-right:45px ;">
                <mat-select formControlName="start_date_minute" [placeholder]="'MINUTES' | translate" required>
                    <mat-option value="00">00</mat-option>
                    <mat-option value="30">30</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="mini-list-header date">
                <input matInput formControlName="end_date" [matDatepicker]="picker2" required
                       placeholder="End">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-error *ngIf="end_date.invalid">{{getErrorMessageEndDate()}}</mat-error>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="mini-list-header time">
                <mat-select formControlName="end_date_hour" [placeholder]="'HOUR' | translate" required>
                    <mat-option value="00">00</mat-option>
                    <mat-option value="01">01</mat-option>
                    <mat-option value="02">02</mat-option>
                    <mat-option value="03">03</mat-option>
                    <mat-option value="04">04</mat-option>
                    <mat-option value="05">05</mat-option>
                    <mat-option value="06">06</mat-option>
                    <mat-option value="07">07</mat-option>
                    <mat-option value="08">08</mat-option>
                    <mat-option value="09">09</mat-option>
                    <mat-option value="10">10</mat-option>
                    <mat-option value="11">11</mat-option>
                    <mat-option value="12">12</mat-option>
                    <mat-option value="13">13</mat-option>
                    <mat-option value="14">14</mat-option>
                    <mat-option value="15">15</mat-option>
                    <mat-option value="16">16</mat-option>
                    <mat-option value="17">17</mat-option>
                    <mat-option value="18">18</mat-option>
                    <mat-option value="19">19</mat-option>
                    <mat-option value="20">20</mat-option>
                    <mat-option value="21">21</mat-option>
                    <mat-option value="22">22</mat-option>
                    <mat-option value="23">23</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="mini-list-header time">
                <mat-select formControlName="end_date_minute" [placeholder]="'MINUTES' | translate" required>
                    <mat-option value="00">00</mat-option>
                    <mat-option value="30">30</mat-option>
                </mat-select>
            </mat-form-field>

            <button class="btn top-list-tools" placement="left"
                    [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
                <fa-icon [icon]="faPlus"></fa-icon>
                {{'ADD'|translate}}
            </button>
        </form>
    </div>


    <br clear="both"/>
</div>

<app-progressbar *ngIf="showSpinner"></app-progressbar>

<table mat-table [dataSource]="schedulers" matSort class="table-striped" style="width:100%">

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
        <td mat-cell *matCellDef="let scheduler"><b>{{scheduler.id}}</b>
        </td>
    </ng-container>
    <ng-container matColumnDef="start_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'START_DATE'|translate}}</th>
        <td mat-cell *matCellDef="let scheduler"><b>{{scheduler.start_date| date:'medium': 'UTC'}}</b>
        </td>
    </ng-container>
    <ng-container matColumnDef="end_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'END_DATE'|translate}}</th>
        <td mat-cell *matCellDef="let scheduler"><b>{{scheduler.end_date| date:'medium': 'UTC'}}</b>
        </td>
    </ng-container>
    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATE'|translate}}</th>
        <td mat-cell *matCellDef="let scheduler"><b>{{scheduler.status}}</b>
        </td>
    </ng-container>
    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>{{'ACTIONS'|translate}}</th>
        <td mat-cell *matCellDef="let scheduler">
            <mat-icon style="color:red;cursor:pointer" (click)="deleteScheduler(scheduler.id)"
                      matTooltipPosition="right"
                      [matTooltip]="'DELETE_ICON_TOOLTIP'|translate">cancel
            </mat-icon>
        </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="5"
></mat-paginator>

<div class="modal-footer">

    <button type="button" class="btn btn-light" (click)="activeModal.close('Close click')"
            [innerHTML]="'CLOSE' | translate">Close
    </button>
</div>